import { LOCATION_CHANGED } from '@takeshape/redux-little-router';
import { all, call, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { createUser, loginUser } from '../auth/actions';
import { getUserId } from '../auth/selectors';
import { build, env, variant, version } from '../config';
import { TRACK_EVENT } from './action-types';
import { runGoogleTagManager } from './providers/google-tag-manager';

const context = {
  app: {
    name: 'TakeShape Client',
    namespace: `com.takeshape.client.${env}`,
    variant,
    version,
    build
  }
};

export const addUserId = (saga) =>
  function* (action) {
    const userId = yield select(getUserId);
    yield* saga(userId, action);
  };

export function* pageTrackingSaga() {
  if (window.analytics) {
    yield call(window.analytics.page, { title: '' }, null, { context });
  }
}

export function* trackConversionSaga(userId) {
  yield call(runGoogleTagManager, userId);
}

export function* identifyUserSaga(userId) {
  if (window.analytics) {
    yield call(window.analytics.identify, userId, null, { context });
  }
}

export function* genericEventTrackingSaga({ payload }) {
  if (window.analytics) {
    if (typeof payload === 'string') {
      yield call(window.analytics.track, payload, null, { context });
    } else {
      const { eventName, data } = payload;
      yield call(window.analytics.track, eventName, data, { context });
    }
  }
}

export default function* root() {
  yield all([
    takeEvery(LOCATION_CHANGED, pageTrackingSaga),
    takeLatest(createUser.FULFILLED, addUserId(trackConversionSaga)),
    takeLatest(createUser.FULFILLED, addUserId(identifyUserSaga)),
    takeLatest(loginUser.FULFILLED, addUserId(identifyUserSaga)),
    takeEvery(TRACK_EVENT, genericEventTrackingSaga)
  ]);
}
